import {
  fetchStudyPlan,
  fetchPlanPreviewResult,
  submitPlanPreview,
  deleteStudyPlan,
} from "../../api/plan";


export default {
  async FETCH_STUDY_PLAN(context, payload) {
    const response = await fetchStudyPlan(payload);
    context.commit("SET_STUDY_PLAN", response.data);
    return response;
  },

  async DELETE_STUDY_PLAN(context, payload) {
    const response = await deleteStudyPlan(payload);
    return response;
  },

  async FETCH_STUDY_PLAN_PREVIEW(context, payload) {
    const response = await fetchPlanPreviewResult(payload);
    context.commit("SET_STUDY_PLAN_PREVIEW", response.data);
    return response;
  },

  async SUBMIT_STUDY_PLAN_PREVIEW(context, payload) {
    const response = await submitPlanPreview(payload);
    return response;
  },
};
